export default "__VITE_ASSET__1_gurLp8__"